export function getWorkTypeMeasurementOptions(workTypes) {
    const seen = new Set();
    return (Array.isArray(workTypes) ? workTypes : [])
        .map(item => String((item && item.unit_of_measurement) || '').trim())
        .filter(value => {
            const key = value.toLocaleLowerCase('ru-RU');
            if (!value || seen.has(key)) return false;
            seen.add(key);
            return true;
        })
        .sort((left, right) => left.localeCompare(right, 'ru-RU', {sensitivity: 'base'}));
}
